import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/ScheduleCall.css';

function ScheduleCall() {
  const { language } = useLanguage();

  const handleScheduleCall = () => {
    window.location.href = 'https://cal.com/team/morrow/intro-call';
  };

  return (
    <div className="schedule-container">
      <h1 className="schedule-title">
        {language === 'en' ? 'Welcome to Morrow Collective.' : 'Willkommen bei Morrow Collective.'}
      </h1>
      <p className="schedule-text">
        {language === 'en'
          ? 'We are driven by getting funding for the pioneers who dare to dream big. At Morrow Collective, we revolutionize the way impactful companies secure non-dilutive funding. Our mission is to simplify the funding process, empowering you to grow sustainably without compromising your equity.'
          : 'Wir sind motiviert, die Pioniere zu unterstützen, die es wagen, groß zu träumen. Bei Morrow Collective revolutionieren wir die Art und Weise, wie wirkungsvolle Unternehmen nicht-dilutive Finanzierung sichern. Unsere Mission ist es, den Finanzierungsprozess zu vereinfachen und Ihnen zu ermöglichen, nachhaltig zu wachsen, ohne Ihre Eigenkapitalanteile zu gefährden.'}
      </p>
      <p className="schedule-text">
        {language === 'en'
          ? 'Say goodbye to roadblocks and bureaucracy, and hello to a seamless path to momentum for your business.'
          : 'Verabschieden Sie sich von Hindernissen und Bürokratie und begrüßen Sie einen nahtlosen Weg zum Erfolg für Ihr Unternehmen.'}
      </p>
      <p className="schedule-text">
        {language === 'en'
          ? 'Your vision deserves the resources to thrive — let\'s make it happen together.'
          : 'Ihre Vision verdient die Ressourcen, um zu gedeihen — lassen Sie uns das gemeinsam verwirklichen.'}
      </p>
      <p className="schedule-text">
        <strong>
          {language === 'en'
            ? 'We are looking forward to talking to you!\nJohannes & Julian'
            : 'Wir freuen uns darauf, mit Ihnen zu sprechen!\nJohannes & Julian'}
        </strong>
      </p>

      <button className="schedule-button" onClick={handleScheduleCall}>
        {language === 'en' ? 'Schedule a Call' : 'Termin vereinbaren'} <strong>→</strong>
      </button>
    </div>
  );
}

export default ScheduleCall;
